module.exports = __webpack_public_path__ + "static/pmmrDesk-5b6271f560174d1eae4dd03f4a3cd310.png";